export default __webpack_public_path__ + "static/daisy-249586206e16134c90c7352e0166547b.jpg";